import { Box, CircularProgress, Link, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { TokenResponse } from '../../../api/DTOtemp'
import AuthenticationProviderInstancesClient from '../../../api/clients/authenticationProviders/AuthenticationProviderInstancesClient'
import sessionService from '../../../services/session/SessionData'

export const ReCaptchaEnterpriseValidation = () => {
	const history = useHistory()

	const params = new URLSearchParams(location.search)
	const providerId = params.get('provider_id')
	const siteKey = params.get('site_key')
	const redirect = params.get('redirect')

	if (providerId === null) throw new Error('provider id not supplied')
	if (redirect === null) throw new Error('redirect not supplied')
	if (siteKey === null) throw new Error('site key not supplied')

	const intProviderId = parseInt(providerId)

	const [token, setToken] = useState<string | undefined>(undefined)
	const [statusText, setStatusText] = useState<string | undefined>(undefined)

	useEffect(() => {
		const script = document.createElement('script')

		script.addEventListener('load', loadListener)
		script.id = 'recaptcha_script'
		script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`

		document.head.appendChild(script)

		function loadListener(this: HTMLScriptElement, ev: Event) {
			console.log('on load event listener!')
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const recaptchaDefined = (globalThis as any).grecaptcha
			console.log(recaptchaDefined)

			recaptchaDefined.enterprise.ready(async () => {
				const tokenPromise = recaptchaDefined.enterprise.execute(siteKey, {
					action: 'LOAD',
				}) as Promise<string>

				tokenPromise.then((v) => {
					setToken(v)
					console.log('token: ', v)
				})
			})
		}

		return () => {
			script.removeEventListener('load', loadListener)
		}
	}, [])

	useEffect(() => {
		if (token === undefined) return

		const authProviderClient = new AuthenticationProviderInstancesClient()
		authProviderClient
			.login(intProviderId, { token })
			.then((v) => {
				const tokenResponse = v.data as TokenResponse

				sessionService.accessToken.setToken(tokenResponse.accessToken)
				sessionService.idToken.setToken(tokenResponse.idToken)
				sessionService.refreshToken.setToken(null)

				history.push(decodeURIComponent(redirect))
			})
			.catch((v) => {
				console.error('error signing user in', v)
			})
	}, [token])

	return (
		<Box
			display="flex"
			height="100%"
			width="100%"
			flex="1"
			flexDirection={'column'}
			justifyContent={'center'}
			alignItems={'center'}
		>
			<Typography paddingBottom={2} variant="h5">
				Making Sure You're Not A Robot...
			</Typography>

			<CircularProgress />

			<Typography paddingTop={2} variant="body2" textAlign={'center'}>
				This page uses Google ReCaptcha Enterprise to silently validate that
				users who access {globalThis.appSettings.APP_NAME} resources are not
				robots.
				<br />
				Please review the Google&nbsp;
				<Link href="https://policies.google.com/privacy">
					Privacy Policy
				</Link>{' '}
				and&nbsp;
				<Link href="https://policies.google.com/terms">Terms of Service</Link>.
			</Typography>
			<Typography variant="body2">
				Please wait, this shouldn't take long.
			</Typography>
			<>
				<script src=""></script>

				<script></script>
			</>
		</Box>
	)
}
